const workletNoop = () => {
  'worklet';
};

const noop = () => {};

export { noop, workletNoop };
